/** @format */

export const CheckLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.0008 21.6L6.40085 16L4.53418 17.8667L12.0008 25.3333L28.0008 9.33334L26.1342 7.46667L12.0008 21.6Z"
                fill={color}
            />
        </svg>
    );
};
